import React from 'react';
import { useCurrency } from '../../contexts/CurrencyContext';

const CurrencyDisplay = ({
  amount,
  showSymbolOnly = false,
  className = '',
  style = {},
  fallback = '0.00'
}) => {
  const { formatAmount, currency } = useCurrency();

  if (amount === null || amount === undefined) {
    return <span className={className} style={style}>{fallback}</span>;
  }

  const formattedAmount = formatAmount(amount, { symbolOnly: showSymbolOnly });

  return (
    <span
      className={`currency-display ${className}`}
      style={style}
      title={currency ? `${currency.name} (${currency.code})` : ''}
    >
      {formattedAmount}
    </span>
  );
};

export default CurrencyDisplay;
